import {Box} from "@mui/material";
import React from "react";
import backgroundVideo from "../../../../video/como-background.mp4";
import {introSectionStyle} from "../../../styles/IntroSectionStyles";
import VideoComponent from "../../../VideoComponent";
import {IntoSection} from "../../common/IntoSection";


const ItalyComoIntroSection = () => {
    return (
        <Box sx={introSectionStyle}>
            <VideoComponent
                backgroundVideo={backgroundVideo}
            />
            <IntoSection
                context={{
                    title: 'italy_como',
                    subtitle:'italy_como_description_title',
                    date: 'italy_como_date',
                    price: 'italy_como_price',
                }}
            />
        </Box>
    );
}

export default ItalyComoIntroSection;
